import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { loadFBX } from "../Scene/LoadFBX";
import { loadOBJ } from "../Scene/LoadOBJ";
import TWEEN from "@tweenjs/tween.js"
import { ClipeModel } from "../Scene/ClipeModel";
import { CSS2DRenderer } from "three/examples/jsm/renderers/CSS2DRenderer";
import { ObjectManager } from "./ObjectManager";
import { SensorHotPoints } from "./SensorHotPoints"
import { ExplodeModel } from "./ExplodeModel"
function SceneManager(id) {
  this.id = id;
  this.objectManager = new ObjectManager(this.id);
}
SceneManager.prototype = {
  constructor: SceneManager,
  id: "",
  scene: null,
  camera_p: null,
  camera_o: null,
  renderer: null,
  uiRenderer: null,
  controls: null,
  clock: new THREE.Clock(),
  clipeModel: null,
  initClipe: false,
  explodeModel: null,
  initExplode: false,
  enableShadow: true,
  mainLight: null,
  lightProbe:null,
  environmentLight: null,
  modelLoader: null,
  objectManager: null,
  hasOpactyMesh: false,
  modelInfo: {},
  modelPath: "",
  modelLoadFinishCallBack: null,
  document: null,
  sensorHotPoints: null,
  object: null,
  hotPointClick: null,
  onSenssionMessage: null,
  action: null,
  mixer: null,
  playAction: false,
  floorUI:null,
  //模型分层展示
  isTopFloor:true,
  isBottomFloor:false,
  bt_UpFloor:null,
  bt_DownFlorr:null,
  floors:[],
  index_floor:0,
  txt_FloorShower:null,
  //初始化场景
  initScene: function (backgroundcolor, document, hotPointClick, onSenssionMessage) {
    this.onSenssionMessage = onSenssionMessage;
    this.hotPointClick = hotPointClick;
    this.document = document;
    let width = window.innerWidth;
    let height = window.innerHeight;
    this.camera_p = new THREE.PerspectiveCamera(45, width / height, 1, 2000); //使用最常见的远景相机，类似于人眼观察的方式。
    this.camera_p.position.set(30, 30, 30);
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(backgroundcolor);
    // this.scene.fog = new THREE.Fog( 0xa0a0a0, 200, 1000 );

    this.objectGroup = new THREE.Group();
    this.scene.add(this.objectGroup);
    // this.setGround();

    this.uiRenderer = new CSS2DRenderer();
    this.uiRenderer.setSize(width, height);
    this.uiRenderer.domElement.style.position = 'absolute';
    this.uiRenderer.domElement.style.top = '0px';

    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(width, height); //宽高可根据实际项目要求更改
    this.renderer.shadowMap.enabled = this.enableShadow;
    this.renderer.localClippingEnabled = true;
    this.renderer.gammaOutput = true;
    this.renderer.gammaFactor = 0.1;
		this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.setControl();
    return [this.renderer.domElement, this.uiRenderer.domElement];
  },
  setFloorUI:function(element){
    this.floorUI=element;
    this.bt_UpFloor=this.floorUI.children[0];
    this.bt_UpFloor.addEventListener('click',()=>this.upFloor(),false);
    this.txt_FloorShower=this.floorUI.children[1];
    this.bt_DownFlorr=this.floorUI.children[2];
    this.bt_DownFlorr.addEventListener("click",()=>this.downFloor(),false);
    if(this.isTopFloor==true){
      this.bt_UpFloor.style.visibility="hidden";
    }
  },
  loadModel: function (modelPath, mapsPath, modeltype, progressCallBack, modelLoadFinishCallBack) {
    this.modelLoadFinishCallBack = modelLoadFinishCallBack;
    this.modelPath = modelPath;
    this.removeAddedModel();
    let type = modeltype;
    switch (type.toLowerCase()) {
      case "fbx":
        this.modelLoader = new loadFBX();
        this.modelLoader.load(modelPath, mapsPath, progressCallBack, (object) => { this.loadObjectFinish(object); });
        break;
      case "obj":
        this.modelLoader = new loadOBJ();
        this.modelLoader.load(modelPath, mapsPath, progressCallBack, (object) => { this.loadObjectFinish(object); });
        break;
    }
  },
  upFloor:function(){
    this.index_floor++;
    this.floors[this.index_floor].visible=true;
    this.txt_FloorShower.innerHTML=this.index_floor+1+"楼";
    if(this.index_floor===this.floors.length-1){
      this.txt_FloorShower.innerHTML="";
      this.bt_UpFloor.style.visibility="hidden";
    }
    else{
      this.bt_UpFloor.style.visibility="visible";
    }
    if(this.index_floor==0){
      this.bt_DownFlorr.style.visibility="hidden";
    }else{
      this.bt_DownFlorr.style.visibility="visible";
    }
  },
  downFloor:function(){
    this.floors[this.index_floor].visible=false;
    this.txt_FloorShower.innerHTML=this.index_floor+"楼";
    this.index_floor--;
    if(this.index_floor===this.floors.length-1){
      this.txt_FloorShower.innerHTML="";
      this.bt_UpFloor.style.visibility="hidden";
    }
    else{
      this.bt_UpFloor.style.visibility="visible";
    }
    if(this.index_floor==0){
      this.bt_DownFlorr.style.visibility="hidden";
    }else{
      this.bt_DownFlorr.style.visibility="visible";
    }
  },
  loadObjectFinish: function (object) {
    console.log("loadObjectFinish", object)
    // 等比缩放并自适应视图（统一处理各种尺寸的模型）
    // fitSize: 目标最大边长（scene 单位），offset: 相机距离放大倍率
    this.fitModelToView(object, this.camera_p, this.controls, { fitSize: 10, offset: 1.25 });
    //如果是楼栋模型，显示楼层切换UI
    if(object.name.indexOf("bd")!=-1){
      this.floorUI.style.visibility="visible";
    }
    if (object.animations) {
      if (object.animations.length > 0) {
        this.mixer = new THREE.AnimationMixer(object);
        this.action = this.mixer.clipAction(object.animations[0]);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
      } else {
      }
    }
    this.objectManager.init(this.modelPath);
    this.object = object;
    this.floors=new Array();
    this.index_floor=this.object.children.length-1;
    this.object.children.forEach((child)=>{
      if(child.name.indexOf("_")!=-1){
        var endString=child.name.split("_")[1];
        if(endString.indexOf("d")!=-1){
          this.floors[this.object.children.length-1]=child;
        }else{
          var i= parseInt(endString.replace("f","").replace("F",""))-1;
         this.floors[i]=child;
        }
        
      }
    });
    var isEmModel = this.modelPath.indexOf("_em");
    object.name = "外部加载的模型";
    this.scene.add(object);
    if (isEmModel != -1) {
      this.objectManager.setAllEmissive(object, this.enableShadow);
    } else {
      this.objectManager.configMaterials(object, this.enableShadow);
      this.modelInfo["sensorPoint"] = this.objectManager.htHotPoints;
      this.modelInfo["hasOpactyMesh"] = this.objectManager.needOpactyMesh.length > 0;
      object.userData.modelInfo = this.modelInfo;
      if (this.modelLoadFinishCallBack) {
        this.modelLoadFinishCallBack(this.modelInfo);
      }
    }

    this.sensorHotPoints = new SensorHotPoints(this.hotPointClick, this.onSenssionMessage);
    this.sensorHotPoints.setHotPoints(this.document, this.modelInfo.sensorPoint, this.scene);
    this.explodeModel = new ExplodeModel(this.scene);
  },
  //移除己有模型
  removeAddedModel: function () {
    if (this.scene) {
      this.scene.children.forEach((child) => {
        if (child.name === "外部加载的模型") {
          this.scene.remove(child);
        }
      });
    }
  },
  setOpacty: function (opacity) {
    this.objectManager.setOpacity(opacity);
  },
  explode: function (value) {
    if (this.action) {
      this.playAction = true;
      if (value) {
        this.action.play();
      } else {
        this.action.stop();
        this.action.reset();
      }
    }
  },
  resetmodel: function () {
    if (this.action) {
      this.playAction = false;
      this.action.stop();
      this.action.reset;
    }
    this.objectManager.resetOpacity(false);
  },
  //手势控制
  setControl: function () {
    this.controls = new OrbitControls(this.camera_p, this.renderer.domElement);
    this.controls.target = new THREE.Vector3(0, 0, 0); //控制目标的坐标（旋转时以此坐标为中心点）
    this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    this.controls.dampingFactor = 0.05;
    this.controls.update();
  },
  //设置地面
  setGround: function () {
    const mesh = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(2000, 2000),
      new THREE.MeshPhongMaterial({ color: 0x999999, depthWrite: false })
    );
    mesh.rotation.x = -Math.PI / 2;
    mesh.receiveShadow = this.enableShadow;
    this.scene.add(mesh);

    const grid = new THREE.GridHelper(2000000, 2000, 0x000000, 0x000000);
    grid.material.opacity = 0.2;
    grid.material.transparent = false;
    this.scene.add(grid);
  },
  animate: function (delta) {
    if (this.playAction) this.mixer.update(delta);
    this.renderer.render(this.scene, this.camera_p);
    // this.uiRenderer.render(this.scene, this.camera_p);
    this.controls.update();
    if (this.objectManager) {
      this.objectManager.update
    }
  },

  fitModelToView: function (object, camera, controls, options) {
    options = options || {};
    const fitSize = options.fitSize !== undefined ? options.fitSize : 1; // 目标最大边长
    const offset = options.offset !== undefined ? options.offset : 1.25;

    // 计算包围盒并按最长边等比缩放到 fitSize
    const box = new THREE.Box3().setFromObject(object);
    const size = new THREE.Vector3();
    box.getSize(size);
    const maxSide = Math.max(size.x, size.y, size.z);
    if (maxSide > 0) {
      const scale = fitSize / maxSide;
      object.scale.set(scale, scale, scale);
    }

    // 重新计算包围球与中心
    box.setFromObject(object);
    const sphere = new THREE.Sphere();
    box.getBoundingSphere(sphere);
    const center = new THREE.Vector3();
    box.getCenter(center);

    // 把模型中心移到原点
    object.position.sub(center);

    // 计算相机距离以使整个包围球进入视野
    let distance = 0;
    if (camera && camera.isPerspectiveCamera) {
      const fov = camera.fov * (Math.PI / 180);
      const radius = sphere.radius;
      distance = Math.abs(radius / Math.sin(fov / 2)) * offset;
      const target = controls ? controls.target.clone() : new THREE.Vector3(0, 0, 0);
      let dir = camera.position.clone().sub(target).normalize();
      if (!isFinite(dir.length())) dir = new THREE.Vector3(1, 1, 1).normalize();
      camera.position.copy(dir.multiplyScalar(distance).add(target));
      camera.near = Math.max(0.1, distance / 100);
      camera.far = distance * 100;
      camera.updateProjectionMatrix();
    } else {
      distance = sphere.radius * (offset * 2);
    }

    if (controls) {
      controls.target.set(0, 0, 0);
      controls.maxDistance = Math.max(1000, distance * 10);
      controls.minDistance = Math.max(0.1, distance * 0.01);
      controls.update();
    }
  },

  //颜色转换

  colorRgb: function (rgb) {
    // 16进制颜色值的正则
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    // 把颜色值变成小写
    var color = rgb.toLowerCase();
    if (reg.test(color)) {
      // 如果只有三位的值，需变成六位，如：#fff => #ffffff
      if (color.length === 4) {
        var colorNew = "#";
        for (var i = 1; i < 4; i += 1) {
          colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
        }
        color = colorNew;
      }
      // 处理六位的颜色值，转为RGB
      var colorChange = [];
      for (var j = 1; j < 7; j += 2) {
        colorChange.push(parseInt("0x" + color.slice(j, j + 2)));
      }
      return "rgb(" + colorChange.join(",") + ")";
    } else {
      return color;
    }
  },

  callBack: function () {
  },

  transformCamera: function (v1, v2) {
    this.animateCamera(this.camera_p.position, this.controls.target, v1, v2, this.callBack);
  },

  tweenanimate: function (time) {
    return TWEEN.update(time);
  },

  animateCamera: function (oldP, oldT, newP, newT, callBack) {
    var tween = new TWEEN.Tween({
      x1: oldP.x, // 相机x
      y1: oldP.y, // 相机y
      z1: oldP.z, // 相机z
      x2: oldT.x, // 控制点的中心点x
      y2: oldT.y, // 控制点的中心点y
      z2: oldT.z  // 控制点的中心点z
    });
    tween.to({
      x1: newP.x,
      y1: newP.y,
      z1: newP.z,
      x2: newT.x,
      y2: newT.y,
      z2: newT.z
    }, 1000);
    tween.onUpdate((object) => {
      this.camera_p.position.set(object.x1, object.y1, object.z1)
      this.controls.target.x = object.x2;
      this.controls.target.y = object.y2;
      this.controls.target.z = object.z2;
      this.controls.update();

    });
    tween.onComplete(() => {
      // this.orbitControl.enabled = true;
      callBack && callBack();
    })
    tween.easing(TWEEN.Easing.Cubic.InOut);
    tween.start();
  },

  //视图重置
  viewReturnOrigin: function (camera, controls) {
    if (this.camera_p) {
      this.camera_p.position.set(30, 30, 30);
      this.camera_p.lookAt(new THREE.Vector3(0, 0, 0));
    }
    if (controls)
      controls.target = new THREE.Vector3(0, 0, 0);
  },
  onWindowResize: function () {
    this.camera_p.aspect = window.innerWidth / window.innerHeight;
    this.camera_p.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.uiRenderer.setSize(window.innerWidth, window.innerHeight);
  },
  clipe: function (i) {
    if (this.initClipe) {
      switch (i) {
        case 0:
          //x轴正方向
          this.clipeModel.clipingFront();
          break;
        case 1:
          //y轴正方向
          this.clipeModel.clipingTop();
          break;
        case 2:
          //z轴正方向
          this.clipeModel.clipingRight();
          break;
        case 3:
          //x轴负方向
          break;
        case 4:
          //y轴负方向
          break;
        case 5:
          //z轴负方向
          break;
      }
    } else {
      this.setModelClipe((i) => { this.clipe(i) }, i);
    }
  },
  closeClipe: function (i) {
    switch (i) {
      case 0:
        this.clipeModel.closeClipingFront();
        //x轴正方向
        break;
      case 1:
        //y轴正方向
        this.clipeModel.closeClipingTop();
        break;
      case 2:
        //z轴正方向
        this.clipeModel.closeClipingRight();
        break;
      case 3:
        //x轴负方向
        break;
      case 4:
        //y轴负方向
        break;
      case 5:
        //z轴负方向
        break;
      case -1:
        //所有
        if (this.initClipe)
          this.clipeModel.resetAll();
        break;
    }
  },
  dont_showAxis(value) {
    if (this.clipeModel)
      this.clipeModel.dontShowAxis(value);
  },
  setModelClipe: function (callBack, i) {
    let modelLoaded = false;
    this.scene.children.forEach((child) => {
      if (child.name === "外部加载的模型") {
        this.clipeModel = new ClipeModel(this.scene, this.camera_p, this.renderer, child, this.controls);
        modelLoaded = true;
      }
    });
    if (modelLoaded) {
      this.initClipe = true;
      callBack(i);

    } else {
      this.$message.info("请等待模型加载完再重试");
      this.initClipe = false;
    }
  },
  configEvironment: function (info, enableShadow) {
    this.enableShadow = enableShadow;
    if (info.enableMainLight) {
      this.setMainLight(info.mainLightIntensity);
    }
    if (info.enableEnvironmentLight) {
      this.setHelpLight(info.environmentLightIntensity);
    }
    this.setLightProde(1.0);
    this.setCameraXPosition(info.camera_x_position);
    this.setCameraYPosition(info.camera_y_position);
    this.setCameraZPosition(info.camera_z_position);
  },
  //设置灯光
  setMainLight: function (intensity) {
    // lights
    this.mainLight = new THREE.DirectionalLight(0xffffff, intensity);
    this.mainLight.name = "主灯";
    // this.mainLight.color.setHSL(0.1, 1, 0.95);
    this.mainLight.position.set(- 1, 1.2, 1);
    this.mainLight.position.multiplyScalar(30);
    this.mainLight.shadow.mapSize.width = 10240;
    this.mainLight.shadow.mapSize.height = 10240;
    this.mainLight.castShadow = this.enableShadow;
    this.mainLight.shadow.camera.left = -500;
    this.mainLight.shadow.camera.right = 500;
    this.mainLight.shadow.camera.top = 500;
    this.mainLight.shadow.camera.bottom = -500;
    this.mainLight.shadow.camera.near=0.5;
    this.mainLight.shadow.camera.far = 500;
    this.mainLight.shadow.bias = - 0.0001;
    // const dirLightHeper = new THREE.DirectionalLightHelper(this.mainLight, 10);
    // this.scene.add(dirLightHeper);
    this.scene.add(this.mainLight);
  },
  //设置lightProde
  setLightProde:function(intensity){
    this.lightProbe=new THREE.LightProbe();
    this.lightProbe.intensity=intensity;
    this.scene.add(this.lightProbe);
  },
  setHelpLight: function (intensity) {
    this.environmentLight = new THREE.HemisphereLight(0xffffff, 0xffffff, intensity);
    this.environmentLight.name = "辅灯";
    // this.environmentLight.color.setHSL( 0.8, 1, 0.8 );
    // this.environmentLight.groundColor.setHSL( 0.9, 1, 0.9 );
    this.environmentLight.position.set(0, 50, 0);
    // const hemilightHelper = new THREE.HemisphereLightHelper(this.environmentLight, 10000);
    // this.scene.add(hemilightHelper);
    this.scene.add(this.environmentLight);
  },
  removeMainLight() {
    this.scene.children.forEach((child) => {
      if (child.name === "主灯") {
        this.scene.remove(child);
      }
    });
  },
  removeHelpLight() {
    this.scene.children.forEach((child) => {
      if (child.name === "辅灯") {
        this.scene.remove(child);
      }
    });
  },
  setBackGroundColor: function (color) {
    this.scene.background = new THREE.Color(color);
  },
  setMainLightIntensity(value) {
    this.mainLight.intensity = value;
  },
  setEnvironmentLightIntensity(value) {
    this.mainLight.intensity = value;
  },
  setCameraXPosition(value) {
    this.camera_p.position.x = value;
    this.camera_p.lookAt(new THREE.Vector3(0, 0, 0))
  },
  setCameraYPosition(value) {
    this.camera_p.position.y = value;
    this.camera_p.lookAt(new THREE.Vector3(0, 0, 0))
  },
  setCameraZPosition(value) {
    this.camera_p.position.z = value;
    this.camera_p.lookAt(new THREE.Vector3(0, 0, 0))
  },
  closeWebSocket: function () {
    if (this.sensorHotPoints) {
      this.sensorHotPoints.closeWebSocket();
    }
  },
  showInfo() {
    this.objectManager.showInfo();
  }
}
export {
  SceneManager
}